import { Button } from '@eventbrite/eds-button';
import {
    PAGE_SIZE_LG,
    PAGE_SIZE_MD,
    PAGE_SIZE_MIN,
} from '@eventbrite/eds-pagination';
import { isSmallDown, isSmallWideDown } from '@eventbrite/eds-utils';
import { getWindowObject, HAS_WINDOW } from '@eventbrite/feature-detection';
import classNames from 'classnames';
import React from 'react';

export const getHost = () => {
    return getWindowObject('location')?.host ?? 'www.eventbrite.com';
};

export const getLocale = () => {
    return Intl.NumberFormat().resolvedOptions().locale;
};

export const scrollToTop = () => {
    if (HAS_WINDOW) {
        window.scrollTo(0, 0);
    }
};

export const getTabItems = (
    currentIndex: number,
    tabs: string[],
    onClick: Function,
    buttonPaths: string[],
    isSmallType: boolean,
) =>
    tabs.map((name, index) => {
        const className = classNames(
            'tab-navigation__item eds-l-pad-hor-3 eds-l-sm-mar-hor-3 eds-l-sw-mar-hor-3 eds-l-pad-top-3',
            {
                'eds-l-pad-bot-2 eds-text-color--grey-900 tab-navigation__item--selected':
                    currentIndex === index,
                'eds-l-pad-bot-3': currentIndex !== index,
                'eds-text-bs': isSmallType,
            },
        );
        let tabButton = null;

        if (buttonPaths) {
            tabButton = (
                <Button
                    key={name}
                    style="none"
                    type="link"
                    href={buttonPaths[index]}
                    __containerClassName={className}
                    onClick={onClick.bind(this, index)}
                >
                    <span>{name}</span>
                </Button>
            );
        } else {
            tabButton = (
                <Button
                    key={name}
                    style="none"
                    __containerClassName={className}
                    onClick={onClick.bind(this, index)}
                >
                    <span>{name}</span>
                </Button>
            );
        }

        return tabButton;
    });

export const getPaginatorSize = () => {
    if (isSmallDown()) {
        return PAGE_SIZE_MIN;
    }

    if (isSmallWideDown()) {
        return PAGE_SIZE_MD;
    }

    return PAGE_SIZE_LG;
};
